export enum Domain {
  Default = 'com',
  BR = 'br',
  MX = 'mx',
  ES = 'es',
  PL = 'pl',
  IT = 'it',
}
